import { render, staticRenderFns } from "./KeyMobile.vue?vue&type=template&id=665b000c&"
import script from "./KeyMobile.vue?vue&type=script&lang=ts&"
export * from "./KeyMobile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports